import * as React from "react";
import * as _ from "lodash";

import {GroupDto} from "../../../../services/Client";
import SelectField, {SelectedValue} from "../../../../components/SelectField";

export interface IRoleSelectionProps {
    /** Displayed when there's no role selected. */
    placeholder?: string;

    /** Data source array. All available roles. */
    groups: GroupDto[];

    /** Initially selected roles. */
    values?: GroupDto[];

    /** Callback when the selected roles change. */
    onChange?: (roles: GroupDto[]) => any;

    readOnly?: boolean;

    searchable?: boolean;
}

/** Return the GroupDto references from the group array that match values. */
export const selectGroups = (groups: GroupDto[], values: GroupDto[]): GroupDto[] => (
    groups.filter(group => _.find(values, value => value.groupName === group.groupName) !== undefined)
);

export const GroupSelection = (props: IRoleSelectionProps) => {
    const selectedValues = selectGroups(props.groups, props.values || []);
    return (
        <SelectField
            placeholder={props.placeholder}
            disabled={props.readOnly}
            multi={true}
            searchable={props.searchable}
            clearable={false}
            dataSource={props.groups}
            value={selectedValues}
            rendererKey={(group: GroupDto) => group.groupName}
            onChange={(selectedValue: Array<SelectedValue>) => {
                if (props.onChange) {
                    const groups = selectedValue.map(value => value.selectedValue as GroupDto);
                    props.onChange(groups);
                }
            }}
        />
    );
};

export default GroupSelection;



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/ProMTGroupsTab/GroupSelection.tsx